import React from 'react';
import PropTypes from 'prop-types';

function Loading({ size = 50 }) {
  const style = {
    borderWidth: `${size / 10}px`,
    width: `${size}px`,
    height: `${size}px`,
  };
  return <div className="loader" style={style} />;
}

Loading.propTypes = {
  size: PropTypes.number,
};

export default Loading;
